"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redactKnownPropertyNames = void 0;
require("core-js/modules/es6.array.map.js");
var _appConfig = _interopRequireDefault(require("@nerdwallet/app-config"));
var _shared = require("./shared");
var _config$API;
/**
 * List of property names that will be redacted. This list is defined in app-configs at
 * https://github.com/NerdWallet/app-configs/pull/5263/files#diff-af2140282c7a0fb185d20a2f015d791f590c5226afa36437e9ef303a3c3c758bR149
 * (@todo: update link once app-configs PR is merged).
 *
 * Don't forget to add a test-case for your property name in the test 'should redact sensitive information'.
 *
 * Also, consider adding a suitable RegExp if the data you want to Redact would be obvious on it's own. For example,
 * +1 (111)-111-1111 is obviously a telephone number even if it appears on it's own as a bare string. Therefore, we
 * have a RegExp for telephone numbers in redactByRegExpPattern.ts.
 *
 * **Note** This implementation is different from app-configs; While the list in app-configs is used in a "input
 * propertyName contains this propertyName", this list is used in a "input propertyName is the same (case-insensitive)
 * as this propertyName". To clarify, adding "token" in app-configs would block "token", "access_token", and
 * "tokenedResponse" (in whatever service uses the app-configs list), here adding token would only redact "token", "Token",
 * "TOKEN" (and other case variations).
 *
 * For a similar "contains" test, you would need to add a suitable RegExp to redactByRegExp.ts file.
 */
var sensitivePropertyNames = ((_appConfig.default === null || _appConfig.default === void 0 ? void 0 : (_config$API = _appConfig.default.API) === null || _config$API === void 0 ? void 0 : _config$API.SENSITIVE_PARAMS) || []).map(function (item) {
  return item.toLowerCase();
});
var redactKnownPropertyNames = exports.redactKnownPropertyNames = {
  // Catch obvious cases of sensitive info (where we have property names we know of).
  test: function test(propertyName) {
    return (
      /* When is a property name not a string? Glad you asked: https://262.ecma-international.org/6.0/#sec-object-initializer
         Now afaik property names are supposed to be auto-coerced to strings, but perhaps it's not true for certain operations 🤷
         context: https://sentry.io/organizations/nerdwallet/issues/2222036359/?project=1230577 */
      sensitivePropertyNames.indexOf(typeof propertyName === 'string' ? propertyName.toLowerCase() : propertyName) !== -1
    );
  },
  replacement: _shared.Redacted
};